(function(){
  'use strict'; 
  jQuery(document).ready(function($) {
    function check_compare(value){
      for (var i = 1; i <=3; i++) {
        if (compare_list['p' + i] == value ) {
          return true
          break;
        } 
      }
      return false;
    }
    
    function convert_currency(value,type){

        try{
          var newCurrency = Currency.currentCurrency;
        }catch(ex){
          var newCurrency = '';
        }
        try{
          var oldCurrency = shopCurrency;
        }catch(ex){
          var oldCurrency = '';
        }
        if(isNaN(value)){
          value =  0.0; 
        }

        var cents = 0.0;
        var oldFormat = Currency.moneyFormats['USD'][ Currency.format] || '';
                                              var newFormat = Currency.moneyFormats[newCurrency][Currency.format] || '';
                                              if(type == 'format'){
                                                return  Currency.formatMoney(value, newFormat);
                                              }
        if (oldFormat.indexOf('amount_no_decimals') !== -1) {
          cents = Currency.convert(parseInt(value, 10)*100, oldCurrency, newCurrency);
        }
        else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
          cents = Currency.convert(parseInt(value, 10)/10, oldCurrency, newCurrency);
        }
        else { 
          cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
        }
        if(type  == 'nosymbol'){
          return cents;
        }
        var my_data =  Currency.formatMoney(cents, newFormat);
        return my_data;
       
      }
    function get_price_only(price){
       var  price_convert= price.toString();
        var get_currencies = 0;
         var $split = price_convert.split(';');
                if($split.length > 1){
                   get_currencies = (isNaN(parseInt( price_convert.substring(1,0)))) ?  $split[1]:  $split[0];
                }else{
                   get_currencies =price_convert.replace(/[^0-9.]/g, '');
                }
                get_currencies = $.trim(get_currencies); 
                var check = get_currencies.substring(1,0);
                if(isNaN((check))){
                get_currencies =   get_currencies.replace(check,'');
                }
          return parseFloat(get_currencies);

      }
    function get_symbol(value){
          var str = value.split("");
          var sym = '';
          for(var i=0;i<str.length;i++){
            if(isNaN(str[i])){
                sym+=str[i];
            }else{
              return sym; 
            }
          }
          return sym;
      }
    
      
      
      
      

        var max_price_slide = convert_currency(30000,'');
        var get_currencies = convert_currency(30000,'');
        var min_price_slide = convert_currency(1000,'');
         
        var $split = get_currencies.split(';');
        if($split.length > 1){
           get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ?  $split[0]+';':  $split[1]+';';

        }else{
           get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ? get_symbol( get_currencies):   get_currencies.substring(1,-1);
        }
    
    $slider_filter = $('#slider-range').slider({
      range: true,
      min: get_price_only(min_price_slide),
      max: get_price_only(max_price_slide),
      values: [get_price_only(min_price_slide), get_price_only(max_price_slide)],

      slide: function(event, ui) {
          var max_price_slide = convert_currency(30000,'');
          var get_currencies = convert_currency(30000,'');
          var min_price_slide = convert_currency(1000,'');
          var $split = get_currencies.split(';');
          if($split.length > 1){
            get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ?  $split[0]+';':  $split[1]+';';

          }else{
            get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ? get_symbol( get_currencies):   get_currencies.substring(1,-1);
          }
          var max_pr = get_currencies + ' ' + ui.values[1];
          var min_pr =  get_currencies +' ' + ui.values[0];

          $(".price_label .from span").html(min_pr);
          $(".price_label .to span").html(max_pr);
        },
      change: function(event, ui) {
        var view_mode = ($(".grid").hasClass('active')) ? '.grid' : '.list';
        $("#loading").show(0);
        var max_price = ui.values[1];
        var min_price =ui.values[0];
        var check = 1;
        var check = 1;
        var sum_product   = 0;
        var page = 0;
        var count;
        $(".shop-products").empty();
        $(".pagination").empty();
         $(".woocommerce-result-count").empty();
        var html = '';
        var has_product = false;
        $.each(json_collection_filter,function(index, elem) { 
           var current_price =  convert_currency(elem.price,'');
              current_price = get_price_only(current_price);
              if (current_price <= max_price && current_price >= min_price) {  
				has_product = true;

                if (sum_product  % 9 === 0) {
                  page++;
                  var count = (sum_product / 9) + 1;
                  $('.pagination').append('<li><a id= "count_'+count+'" class="paginate ' + count + '" >' + count + '</a></li>');
                }
                
                html +='<div class="col-xs-12 col-sm-4 listproduct page_count_'+page+'">';
              	html +=   json_to_html(elem);
                
                sum_product++;
            }
        });
        
        if (sum_product  <= 9) {
        	  $('.pagination').hide();
        }
        
        if(! has_product){
            html +='<p class="text-center"> No products were found matching your selection.</p>';
          }
        //showing results
          var htmlresult ='';
         	 htmlresult += '<p class="woocommerce-result-count"> Results '+sum_product+' products  filter </p>';
          $(".woocommerce-result-count").append(htmlresult);
        $(".shop-products").append(html);

        $(view_mode).trigger('click');
        window.setTimeout(function() {
          $("#loading").hide(700);
        }, 1000);
        
         $("#count_1").trigger("click");
        
      } 
    });
    $("#amount").val("$" + $("#slider-range").slider("values", 0) +
                     " — $" + $("#slider-range").slider("values", 1));


    function json_to_html(product){
      // shop-products
      var  is_sale = false;
      if(product.compare_at_price > product.price){is_sale =true}
      var $html = '';
      $html +='<div class="product-item">';
      $html +='<div class="list-col4 col-xs-12 col-sm-4">';
      $html +='<a href="/products/'+product.handle+'" title="'+product.title+'" class="sale-box">';
      if(is_sale){
        $html=$html+' <span class="label-sale product-label">Sale</span>';
      }
      $html +='</a>';
      $html +='<div class="label-product"> ';
      $html += '</div>';
      $html += '<div class="product-image">';
      $html += '<a href="'+product.handle+'" title="'+product.title+'"></a>';
      $html += '<a href="'+product.handle+'" title="'+product.title+'">';
      $html += '<figure class="first-image">';
      $html += ' <img src="'+product.featured_image+'" alt="'+product.title+'">';
      $html += '</figure>';
      $html += '<figure class="second-image">';
      if(product.images.length > 1)
      {
        $html += '<img src="'+product.images[1]+'" alt="'+product.title+'" class="image-visible-hidden">';
      }
      
      $html += '</figure>';
      $html += '<span class="shadow"></span>';
      $html += '</a>';
      $html += '<div class="quickview2">';
      $html += '<div class="quickviewbtn">';
      $html += '<a class="detail-link quick-view" data-quick-id="'+product.variants[0].id +'" href="'+product.handle+'" title="Quick view">Quick View</a>';
      $html += '</div>';
      $html += '</div>';
      $html += '<div class="actions2">';
      $html += '<div class="action-buttons">';
      $html += '<div class="product-quick-view">';
      $html += '<a href=\'/products/'+product.handle+'\'" data-pid="'+product.variants[0].id +'" class="quick-view action-home4" title="" data-toggle="tooltip" data-placement="top" data-original-title="Quick view"><i class="fa fa-eye"></i></a>';
      if(is_customers){
        $html +='<a class="wishlist action-home4" href="" data-pid="'+product.handle+'"> Add to Wishlists<i class="fa fa-heart-o"></i></a>';
        $html +='<a href="/collections/wishlist" class="added-wishlist action-home4" title="Browse wishlist" data-toggle="tooltip" data-placement="top" ><i class="fa fa-heart-o"></i></a>';
      }else {
        $html += '<a class="wishlist-login action-home4"   href="javascript:void(0)" title="Add to wishlist" data-toggle="tooltip" data-placement="top"><i class="fa fa-heart-o"></i></a>';
      } 

      $html += '<a href="#" class="compare action-home4" data-pid="'+product.handle+'" title="" data-toggle="tooltip" data-placement="top" data-original-title="Compare product"><i class="fa fa-retweet"></i></a>';
      $html += '</div>';
      $html += '</div>';
      $html += '<div class="add-to-cart-h4">';
      $html += '<div class="pro-add-to-cart">';
      if((product.variants).length> 1){
        $html += '<p><a href="#" class="add-to-cart" title="Select Options" onclick="location.href=\'/products/'+product.handle+'\'">Select Options</a></p>';
      }else{
        $html += '<p><a href="#" title="Add to Cart" data-pid="'+product.variants[0].id+'" class="add-to-cart">Add to Cart</a><span class="check-cart"></span> </p>';
        $html += '<span class="adding-cart"></span>';
      }
      $html += '</div>';
      $html += '</div>';
      $html += '</div>';
      $html += '</div>';
      $html += '<div class="product-overlay">';
      $html += '<span class="shopify-product-reviews-badge" data-id="' + product.id + '"></span> ';
      $html += '<div class="pro-add-to-cart">';
      if((product.variants).length> 1){
        $html += '<p><a href="#" class="add-to-cart" title="Select Options" onclick="location.href=\'/products/'+product.handle+'\'">Select Options</a></p>';
      }else{
        $html += '<p><a href="#" title="Add to Cart" data-pid="'+product.variants[0].id+'" class="add-to-cart">Add to Cart</a><span class="check-cart"></span> </p>';
        $html += '<span class="adding-cart"></span>';
      }
      $html += '</div>';
      $html += '<div class="product-quick-view">';
      if(is_customers){
        $html +='<a class="wishlist action-home4" href="" data-pid="'+product.handle+'"> Add to Wishlists<i class="fa fa-heart-o"></i></a>';
        $html +='<a href="/collections/wishlist" class="added-wishlist action-home4" title="Browse wishlist" data-toggle="tooltip" data-placement="top" ><i class="fa fa-heart-o"></i></a>';
      }else {
        $html += '<a class="wishlist-login action-home4"   href="javascript:void(0)" title="Add to wishlist" data-toggle="tooltip" data-placement="top"><i class="fa fa-heart-o"></i></a>';
      }
     if(check_compare(product.handle)){
       $html +='    <a class="compare added" href="" data-pid="'+product.handle+'">Added to Compare</a>';
     }else{
       $html +='    <a class="compare" href="" data-pid="'+product.handle+'">Add to Compare</a>';
     }      
      $html += '<a href=\'/products/'+product.handle+'\'" data-pid="'+product.variants[0].id+'" class="quick-view" title="" data-toggle="tooltip" data-placement="top" data-original-title="Quick view"><i class="fa fa-eye"></i></a>';
      $html += '</div>';
      $html += '</div>';
      $html += '</div>';
      $html += '<div class="list-col8 col-xs-12 col-sm-8">';
      $html += '<div class="product-text">';
      $html += '<h2><a class="product-title" href="/products/'+product.handle+'" title="'+product.title+'">'+product.title+'</a></h2>';
      $html += ' <div class="product-price">';
      $html += '<strong>On Sale</strong><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.price,'11')+'">'+convert_currency(product.price,'11')+'</span>';
      $html += '<span class="visually-hidden">Regular price</span>';
      if(convert_currency(product.compare_at_price,'nosymbol') > 0){
        $html += '<s><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.compare_at_price,'11')+'">'+convert_currency(product.compare_at_price,'11')+'</span></s>'; 
      }
      $html += '</div>';
      $html += '</div>';
      $html += '<div class="listview">';
      $html += '<div class="price-box">';
      $html += '<strong>On Sale</strong><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.price,'11')+'">'+convert_currency(product.price,'11')+'</span>';
      $html += '<span class="visually-hidden">Regular price</span>';
      if(convert_currency(product.compare_at_price,'nosymbol') > 0){
        $html += '<s><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.compare_at_price,'11')+'">'+convert_currency(product.compare_at_price,'11')+'</span></s>'; 
      }
      $html += '</div>';
      $html += '<div class="product-name">';
      $html += '<h2><a class="product-title" href="/products/'+product.handle+'" title="'+product.title+'">'+product.title+'</a></h2>';
      $html += '</div>';
      $html += '<div class="product-desc">';
      $html += '<p>'+ product.content+'</p>';
      $html += '</div>';
      $html += '<div class="actions">';
      $html += '<div class="add-to-cart-h4">';
      if((product.variants).length> 1){
        $html += '<p><a href="#" class="button add-to-cart add_to_cart_inline" onclick="location.href=\'/products/'+product.handle+'\'">Select Options</a></p>';
      }else{
        $html += '<p><a href="#" class="button add-to-cart" title="Add to Cart" data-pid="'+product.variants[0].id+'">Add to Cart</a><span class="check-cart"></span></p>';
		$html += '<span class="adding-cart"></span>';
      }
      $html += '</div>';
      $html += '<div class="add-to-links">';
      $html += '<div class="btn-add-to-wishlist">';
      if(is_customers){
        $html +='<a class="wishlist action-home4" href="" data-pid="'+product.handle+'"> Add to Wishlists<i class="fa fa-heart-o"></i></a>';
        $html +='<a href="/collections/wishlist" class="added-wishlist action-home4" title="Browse wishlist" data-toggle="tooltip" data-placement="top" ><i class="fa fa-heart-o"></i></a>';
      }else {
        $html += '<a class="wishlist-login action-home4"   href="javascript:void(0)" title="Add to wishlist" data-toggle="tooltip" data-placement="top"><i class="fa fa-heart-o"></i></a>';
      }
      $html += '</div>';
      $html += '<div class="clear"></div>';
      $html += ' <div class="btn-compare">';
      if(check_compare(product.handle)){
         $html +='<a class="compare added" href="#" data-pid="'+product.handle+'" title="" data-toggle="tooltip" data-placement="top" data-original-title="Compare product">Added to Compare</a>';
       }else{
         $html +='<a class="compare" href="#" data-pid="'+product.handle+'" title="" data-toggle="tooltip" data-placement="top" data-original-title="Compare product">Add to Compare</a>';
       }
     
      $html += '</div>';
      $html += '</div>';
      $html += '</div>';
      $html += '</div>';
      $html += '</div>';
      $html += '</div>';
      $html += '</div>';
      return $html ;
    }

    $("#amount").val(Currency.currentCurrency + " " + $("#slider-range").slider("values", 0) + " - " + Currency.currentCurrency +" "+ $("#slider-range").slider("values", 1));
  
	});
})(jQuery);